(function($) {

    function toggle_company_vat($checkbox){
        let $form = $checkbox.closest('form');
        let $field = $form.find(".checkout_form__vat-number");
        let $address_2 = $form.find('#billing_address_2_field');

        if ($checkbox.is(':checked')) {
            // show
            if($address_2.length && $address_2.position().left > 5){
                $field.show().css('width', '0').animate({width: '100%'}, 250);
            }else{
                $field.slideDown(250);
            }
        } else {
            // hide
            if($address_2.length && $address_2.position().left > 5){
                $field.animate({width: '0'}, 250, function() {
                    $(this).hide().css('width', '');
                });
            }else{
                $field.slideUp(250);
            }
        }
    }

    function init_form_toggles() {
        // Initial state for VAT toggle
        $("input[name='show_company_vat']").each(function() {
            let $checkbox = $(this);
            let $form = $checkbox.closest('form');
            let $field = $form.find(".checkout_form__vat-number");
            if ($checkbox.is(':checked')) {
                $field.show();
            } else {
                $field.hide();
            }
        });

        // Initial state for Company Info toggle
        $("input[name='show_company_info']").each(function() {
            let $checkbox = $(this);
            let $form = $checkbox.closest('form');
            let $field = $form.find(".checkout_form__company");
            if ($checkbox.is(':checked')) {
                $field.show();
            } else {
                $field.hide();
            }
        });

        // Initial state for Shipping toggle
        $("input[name='ship_to_different_address']").each(function() {
            let $checkbox = $(this);
            let $form = $checkbox.closest('form');
            let $field = $form.find(".checkout_form__shipping");
            if ($checkbox.is(':checked')) {
                $field.show();
            } else {
                $field.hide();
            }
        });
    }

    $(document).ready(function() {
        init_form_toggles();

        $(document).on("change", "input[name='show_company_vat']", function() {
            toggle_company_vat($(this));
        });

        $(document).on("change", "input[name='show_company_info']", function() {
            let $checkbox = $(this);
            let $form = $checkbox.closest('form');
            let $field = $form.find(".checkout_form__company");

            if ($checkbox.is(':checked')) {
                $field.slideDown(250);
            } else {
                $field.slideUp(250);
            }
        });

        $(document).on("change", "input[name='ship_to_different_address']", function() {
            let $checkbox = $(this);
            let $form = $checkbox.closest('form');
            let $field = $form.find(".checkout_form__shipping");

            if ($checkbox.is(':checked')) {
                $field.slideDown(250);
            } else {
                $field.slideUp(250);
            }
        });

        // phone country code select2
        $('.js-select2').select2().on('select2:open', function (e) {
            // auto-focus only on non-touch devices - it should prevent virtual keyboard popup
            if(!window.matchMedia("(pointer: coarse)").matches){
                const selectId = e.target.id;
                let element = $(`[aria-controls="select2-${selectId}-results"]`).get(0);
                element.focus();
            }
        });
    });

})(jQuery);
